<div class="mobile-categories">
  <div class="categories-mobile-btn" (click)="toggleCategoriesDropdown()">
    <i class="icon-Funnel"></i>
    <span class="text--semi-bold">{{ 'Categories' | translate }}</span>
    <span class="selected-count text--semi-bold">{{ selectedCategoriesCount }}</span>
  </div>
  @if (isOpenSubject | async) {
    <div class="categories-dropdown">
      @if (categoriesList && categoriesList.length) {
        <section class="categories-list">
          <span>
            <mat-checkbox
              [checked]="isAllChecked"
              [indeterminate]="isSomeChecked && !isAllChecked"
              (change)="updateAll()"
            >
              {{ 'All' | translate }}
            </mat-checkbox>
          </span>
          <ul>
            @for (item of categoriesList; track item.id;) {
              <li>
                <mat-checkbox [checked]="item.checked" (click)="updateList(item)">
                  <div class="ellipsis">{{ item.name }}</div>
                </mat-checkbox>
                {{ item.count }}
              </li>
            }
          </ul>
        </section>
      }
      <div class="buttons-row">
        <app-button [ariaLabel]="`Cancel`|translate "  [buttonStyleType]="BUTTON_TYPES.SECONDARY_0" (click)="cancel()">{{ `Cancel`|translate }}
        </app-button>
        <app-button [ariaLabel]="'Apply' | translate" [buttonStyleType]="BUTTON_TYPES.PRIMARY_0" (click)="emitSelectedCategories()">{{ 'Apply' | translate }}</app-button>
      </div>
    </div>
  }
</div>
